import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

/** Marca de la aplicación usada en el título del navegador. Punto único de verdad. */
export const APP_BRAND = "CENTROS";

/**
 * Título del navegador centralizado:
 *  - Landing / fallback → "CENTROS".
 *  - Resto de páginas → "CENTROS | Título de la página".
 *
 * Se registra como override de `Title` (provide: Title, useClass: BrandTitleService), de modo que
 * todos los `setTitle(...)` que ya hacen las páginas se prefijan automáticamente sin tocar cada
 * componente. Para ajustar la marca o las mayúsculas, cambiar SOLO aquí (APP_BRAND / el formato).
 */
@Injectable()
export class BrandTitleService extends Title {
	constructor(@Inject(DOCUMENT) doc: Document) {
		super(doc);
	}

	override setTitle(pageTitle: string): void {
		const page = (pageTitle ?? "").trim();
		// Solo la marca EXACTA (la que fija la landing) se muestra en seco; cualquier otro título
		// se prefija, aunque coincida sin distinguir mayúsculas (p. ej. "Centros" -> "CENTROS | Centros").
		const full =
			!page || page === APP_BRAND ? APP_BRAND : `${APP_BRAND} | ${page}`;
		super.setTitle(full);
	}
}
